import {camelCase} from 'lodash'

export default {
    name: 'breadcrumb',
    props: {
        route: {},
        disabled:{
            required: true,
            type: Boolean
        }
    },
    beforeCreate() {
        this.$options.computed.value = function () {
            if (this.route.bcGetter) {
                return this.$store.getters[`${this.route.bcModule}/${this.route.bcGetter}`]
            } else {
                return null
            }
        }
    },
    created() {
    },
    computed: {
        formattedValue() {
            return this.value ? this.value.name : null
        },
    },
    methods: {
        toCamelCase(val) {
            return camelCase(val)
        }
    }
}
